/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_5_DInputs */

const en_mk_tut_gl_5_d = /** @type {(inputs: Mk_Tut_Gl_5_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The permission an agent asks for before doing anything that leaves the company.`)
};

const id_mk_tut_gl_5_d = /** @type {(inputs: Mk_Tut_Gl_5_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izin yang diminta agen sebelum melakukan tindakan yang keluar dari perusahaan.`)
};

/**
* | output |
* | --- |
* | "The permission an agent asks for before doing anything that leaves the company." |
*
* @param {Mk_Tut_Gl_5_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_5_d = /** @type {((inputs?: Mk_Tut_Gl_5_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_5_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_5_d(inputs)
	return en_mk_tut_gl_5_d(inputs)
});